import { queries } from '@/features/_lib/react-query'
import { useQuery } from '@tanstack/react-query'
import { companyColumns } from '../../_columns/company-table-column'
import { DataTable } from '../../_components/data-table'
import { LoadingDataTable } from '../../_components/loading-data-table'

interface CompaniesTableProps {
  search?: string
}

export const CompaniesTable = ({ search }: CompaniesTableProps) => {
  const { data, isLoading } = useQuery(queries.staffCompanies.list)

  if (isLoading) return <LoadingDataTable columns={companyColumns} />

  const companies = data?.companies ?? []

  const filteredCompanies = companies.filter((company) =>
    company.name.toLowerCase().includes((search ?? '').toLowerCase()),
  )

  return <DataTable columns={companyColumns} data={filteredCompanies} />
}
